import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children, ctaHref = '/#contato' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#conteudo'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-primary focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-primary-foreground'
            >
                Pular para o conteúdo
            </a>

            <SiteHeader ctaHref={ctaHref} />

            <main id='conteudo' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            <SiteFooter ctaHref={ctaHref} />
        </div>
    )
}
